import { SerializedStyles } from "@emotion/react";
import { Ref, memo } from "react";
import { HeaderText } from "src/components/v1";
import { useMobileHeightAdjustment } from "src/hooks";
import Loading from "src/images/loading.gif";
import { createStyles } from "src/styles";

import { styles } from "../styles";

export interface LoadingApplicationProps {
  style?: SerializedStyles;
  focusRef?: Ref<HTMLInputElement>;
}

const INNER_STYLES = createStyles({
  page: {
    padding: 20,
    backgroundColor: "white",
  },
  header: {
    fontSize: 36,
    marginTop: 32,
  },
  image: {
    width: "100%",
    maxWidth: 456,
  },
});

const LoadingApplication = ({ style, focusRef, ...props }: LoadingApplicationProps) => {
  const height = useMobileHeightAdjustment();

  return (
    <div {...props} ref={focusRef} css={[styles.page, INNER_STYLES.page, { height }, style]}>
      <img css={INNER_STYLES.image} alt="loading icon" src={Loading} />
      <HeaderText style={[styles.centeredText, styles.header, INNER_STYLES.header]}>
        Loading your application...
      </HeaderText>
    </div>
  );
};

export default memo(LoadingApplication);
